<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-money fa-lg"></i> {{ $t('investmentOpportunity.title') }}
        <createButton v-if="canCreateInvestmentCompany" name="investment_opportunity_innovation_create" :title="$t('investmentOpportunity.innovation.create.title')"></createButton>
        <createButton v-if="canCreateInvestmentProperty" name="investment_opportunity_property_create" :title="$t('investmentOpportunity.property.create.title')"></createButton>
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>
       
        <div class="table-responsive">
          <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th class="export">{{ $t('project.investment.form.id') }}</th>
                <th>{{ $t('project.investment.form.project') }}</th>
                 <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('investmentOpportunity.form.areaOfActivities') }}</th>
                <th class="drop-down-filter">{{ $t('investmentOpportunity.form.stage') }}</th>
                <th>{{ $t('investmentOpportunity.form.creationDate') }}</th>
                <th class="drop-down-filter">{{ $t('investmentOpportunity.form.region') }}</th>
               
                <th class="no-sort no-filter" width="100" v-if="canCreate || canDelete">&nbsp;</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th class="export">{{ $t('project.investment.form.id') }}</th>
                <th>{{ $t('project.investment.form.project') }}</th>
                 <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('investmentOpportunity.form.areaOfActivities') }}</th>
                <th class="drop-down-filter">{{ $t('investmentOpportunity.form.stage') }}</th>
                <th>{{ $t('investmentOpportunity.form.creationDate') }}</th>
                <th class="drop-down-filter">{{ $t('investmentOpportunity.form.region') }}</th>
               
                <th class="no-sort no-filter" width="100" v-if="canCreate || canDelete">&nbsp;</th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="entite in entites" v-bind:data-id="entite.id" :key="entite.id" @click="view(entite)" class="clickable-row">
                <td>{{ entite.id }}</td>
                <td>
                   {{ businessNameToDisplay(entite) }}
                </td>
                 <td>{{ entite.projectTypeText }}</td>
                <td>
                   {{ entite.branchesOfActivity }}
                </td>
                 <td>
                    {{ entite.stageText }}
                </td>
                 <td>
                   {{ entite.creationTimeText }}
                </td>
                <td>
                   {{ entite.headOfficeAddress.regionText }}
                </td>
               

                <td class="no-sort" align=center v-if="canCreate || canDelete">
                  <div>
                    <a href="#" v-if="canReallyCreate(entite)" v-bind:title="$t('form.edit_button')" v-on:click.stop="edit(entite)">
                      <span class="fa fa-lg fa-pencil"></span>
                    </a>
                    <!-- <a href="#" v-else v-bind:title="$t('form.edit_button')">
                      <span class="fa fa-lg fa-pencil text-muted"></span>
                    </a> -->
                    &nbsp;
                       <a
                  href="#"
                  v-if="canReallyCreate(entite)"
                  v-bind:title="$t('form.copy_button')"
                  v-on:click.stop="copy(entite)"
                >
                  <span class="fa fa-lg fa-copy"></span>
                </a>
                <!-- <a href="#" v-else v-bind:title="$t('form.copy_button')">
                  <span class="fa fa-lg fa-copy text-muted"></span>
                </a> -->
                &nbsp;
                    <a class="text-danger" v-if="canReallyDelete(entite)" v-bind:title="$t('form.delete_button')" href="#" v-on:click.stop="deleteEntity(entite.id)">
                      <span class="fa fa-lg fa-trash"></span>
                    </a>
                    <!-- <a class="text-danger" v-else v-bind:title="$t('form.delete_button')">
                      <span class="fa fa-lg fa-trash text-muted"></span>
                    </a> -->
                  </div>
                  <!-- <div v-if="entite.processStatus == 4">
                    <span class="fa fa-lg fa-pencil text-muted"></span>
                    &nbsp;
                    <span class="fa fa-lg fa-trash text-muted"></span>
                  </div> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {InvestmentOpportunityServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'
import permission from '../../shared/permission'

export default {
  name: 'InvestmentOpportunities',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: InvestmentOpportunityServiceClient,
    }
  },
  computed: {
    canCreateInvestmentProperty: function() {
      return permission.checkPermission(['Pages.Projects.Property.Create'])
    },
    canCreateInvestmentCompany: function() {
      return permission.checkPermission(['Pages.Projects.Company.Create'])
    },
  },
  methods: {
    businessNameToDisplay: function(entite) {
      if (entite.projectId != null) {
        return entite.project.entreprise.name
      }
      return entite.businessName
    },
    canReallyCreate: function(entite) {
      var validatePermission = 'Pages.Projects.Property.Create'
      if (entite.projectType == 1) validatePermission = 'Pages.Projects.Company.Create'

      return (
        (permission.checkPermission([validatePermission]) || permission.checkPermission(['Pages.Members.Junior.Seulement'])) &&
        this.canCreate
      )
    },
    canReallyDelete: function(entite) {
      var validatePermission = 'Pages.Projects.Property.Delete'
      if (entite.projectType == 1) validatePermission = 'Pages.Projects.Company.Delete'

      return permission.checkPermission([validatePermission]) && this.canDelete
    },
    fetchData: function() {
      let service = ServiceFactory.create(this.serviceClient)
      let self = this

      let investmentOpportunityId = this.$route.params.investmentOpportunity_id
      let investmentType = undefined

      service
        .getAll('', 0, 10000)
        .then(res => {
          self.entites = res.items
          self.showDataTable()
        })
        .catch(err => {
          self.error = self.getErrorMessage(err)
        })
    },
    view: function(entite) {
      this.redirectTo(entite, 'view')
    },
    edit: function(entite) {
      this.redirectTo(entite, 'edit')
    },
    copy: function(entite) {
      this.redirectTo(entite, 'copy')
    },
    redirectTo: function(entite, mode) {
      var route = entite.projectType != 1 ? 'property' : 'innovation'
      this.$router.push({
        name: 'investment_opportunity_' + route + '_' + mode,
        params: {id: entite.id},
      })
    },
    totalDeboursement: function(entite) {
      let totalValues = _.sumBy(entite.investmentValues, function(x) {
        return parseInt(x.value)
      })
      return totalValues === parseInt(entite.totalValue)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .dataTables_wrapper{
    padding: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/InvestmentOpportunity/InvestmentOpportunity.vue